import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import ProductIcon from '../../common/ProductIcon';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { Inbound25CopyChange } from '../../common/i18n/CopyChangeComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StarterCustomerPlatformUpsellCardFeatures = ({
  currentProductLine,
  loading
}) => {
  // display all product lines except the current product line (the hub page you are on)
  const DisplayedProductLines = AllProductLines.filter(productLine => productLine !== currentProductLine);
  const HeaderSection = /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `merchCards.starterCustomerPlatformUpsellCard.priorityFeatures.header.${currentProductLine}`
    })
  });
  const FeaturesListSection = /*#__PURE__*/_jsx(List, {
    children: DisplayedProductLines.map((localProductLine, index) => {
      return /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: index > 0 ? '300' : undefined,
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          name: localProductLine,
          iconStyle: {
            blockSize: '24px',
            marginInlineEnd: '300'
          }
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "body-125",
            children: /*#__PURE__*/_jsx(Inbound25CopyChange, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `merchCards.starterCustomerPlatformUpsellCard.priorityFeatures.${localProductLine}.title`
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `merchCards.starterCustomerPlatformUpsellCard.priorityFeatures.${localProductLine}.subtext`
            })
          })]
        })]
      }, localProductLine);
    })
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: false,
    loading: loading
  });
};